require("./main.ts");



//////////////////
// WEBPACK FOOTER
// ./Websites/FrontierEnterprise.Web/@static/@modules/fiber-plan-estimator/index.js
// module id = 53
// module chunks = 23